export class Adhesive {

    public id: number;
    public name: string;
    public description: string;

    constructor(adhesive: any = {}) {
        this.id = adhesive.id || null;
        this.name = adhesive.name || '';
        this.description = adhesive.description || '';
    }

}
